<template>
  <div>
  <div class="bg-gray">
    <div class="container-fluid">
      <div class="user-card">
        <h2>Posts</h2>

        <button @click="showingCreate = true" class="btn btn-primary">Create</button>

      </div>
    </div>
  </div>
  <create-post :showing="showingCreate" @close="showingCreate = false" @create="submitCreate" :existing="editAward" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { StoreActions } from "./store/actions";
import StoreIndex from "./store/_StoreIndex";
import {StoreState as state} from './store/state'
import CreatePost from "@/components/swiftspace/posts/CreatePost.vue";

export default {
  name: "Posts",
  components: {
    CreatePost
  },
  data() {
    return {
      suspendConfirm: false,
      showingCreate: false,
      editAward: null
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      // this.dispatch(StoreActions.search);
    },
    commit(path, value) {
      this.$store.commit(`${StoreIndex.path}/${path}`, value);
    },
    dispatch(path, value) {
      this.$store.dispatch(`${StoreIndex.path}/${path}`, value);
    },
    submitCreate(form) {
      this.dispatch(StoreActions.create, form);
    }
  },
  computed: {
    ...mapState(StoreIndex.path,[
        state.results,
        state.page
    ])
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card-header {
  background: #46c3f0;
  color: white;
}
a {
  color: black;
  font-weight: bold;
}

.btn-secondary {
  background: lightgray;
  border-color: lightgray;
}

@media (max-width: 700px) {
  .mobile-hide {
    display: none;
  }
}

@media (min-width: 701px) {
  .large-hide {
    display: none;
  }
}

.user-card {
  background: white;
  margin: 20px;
  border-radius: 10px;
}

.user-img {
  border-radius: 10px;
  margin: 10px;
}

label {
  color: gray;
  font-weight: bold;
}

.user-photo {
  width:100px;
  height:100px;
  border-radius: 50px;
  object-fit: cover;
}

@media (max-width:767px) {
  .user-photo {
    width: 50px;
    height: 50px;
    border-radius: 25px;
  }
}
</style>